if (!customElements.get('configurator-config')) {
    customElements.define(
        'configurator-config',
        class ConfiguratorConfig extends HTMLElement {
            constructor() {
                super();

                this.textEl = this.querySelector('#configurator-text');
                this.fieldsEl = this.querySelector('.configurator-fields');
                this.msgEl = this.querySelector('.configurator-msg');

                // Buttons
                this.textToUiBtn = this.querySelector('#text-to-ui');
                this.uiToTextBtn = this.querySelector('#ui-to-text');
                this.clipboardBtn = this.querySelector('#clipboard');
                this.createNew = this.querySelector('#create-new');

                // Templates
                this.configuratorTemplate = this.querySelector('#configurator-template');
                this.optionTemplate = this.configuratorTemplate.content.querySelector('#configurator-option');
                this.valueTemplate = this.optionTemplate.content.querySelector('#configurator-value');

                this.configJson = null;

                this.message = {
                    'wrong_text': {
                        'msg_text': 'Cannot convert the Configurator Text to UI. Please check again!',
                        'class': 'error'
                    },
                    'text_copied': {
                        'msg_text': 'Copying to clipboard was successful!',
                        'class': 'success'
                    },
                    'ui_to_text_success': {
                        'msg_text': 'Convert successfully!',
                        'class': 'success'
                    },
                    'ui_to_text_failed': {
                        'msg_text': 'Cannot convert to Json Text. Please check the empty fields!',
                        'class': 'error'
                    }
                };

                this.defaultJson = {
                    'data': [],
                    'template': {
                        "step_by_step_configurator":"1",
                        "display_name":"",
                        "description":""
                    }
                };

                this.init();
            }

            async init(){

                this.textToUiBtn.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.removeMsg();
                    this.convertTextToUi();
                });

                this.uiToTextBtn.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.removeMsg();
                    this.convertUiToText();
                });

                this.clipboardBtn.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.removeMsg();
                    this.textEl.select();
                    this.textEl.setSelectionRange(0, 99999);
                    navigator.clipboard.writeText(this.textEl.value);
                    this.renderMsg('text_copied');
                });

                this.createNew.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.removeMsg();
                    this.convertTextToUi(true);
                });

            }

            convertTextToUi(isNew=false){
                try{
                    const textValue = isNew ? null : JSON.parse(this.textEl.value);
                    if(textValue || isNew){
                        if(isNew){
                            this.configJson = this.defaultJson;    
                        }else{
                            this.configJson = textValue;
                        }

                        this.fieldsEl.innerHTML = '';

                        const configuratorEl = this.configuratorTemplate.content.cloneNode(true);

                        // template info
                        const templateInfoEl = configuratorEl.querySelector('.conf--template-info');
                        this.storeExistingTranslations(templateInfoEl, this.configJson['template']);
                        configuratorEl.querySelector('input[name="display_name"]').value = this.configJson['template']['display_name'] ?? '';
                        configuratorEl.querySelector('input[name="display_name_en"]').value = this.getTranslationValue(this.configJson['template'], 'display_name');
                        configuratorEl.querySelector('textarea[name="description"]').value = this.configJson['template']['description'] ?? '';
                        configuratorEl.querySelector('textarea[name="description_en"]').value = this.getTranslationValue(this.configJson['template'], 'description');
                        configuratorEl.querySelector('input[name="step_by_step_configurator"]').checked = (this.configJson['template']['step_by_step_configurator'] == '1') ? true : false;

                        // option
                        if(this.configJson['data']){
                            const optionsEl = configuratorEl.querySelector('.conf--options');
                            this.configJson['data'].forEach(option => {
                                const optionEl = this.optionTemplate.content.cloneNode(true);
                                const optionRootEl = optionEl.querySelector('.conf--option');

                                this.storeExistingTranslations(optionRootEl, option);
                                optionEl.querySelector('input[name="option_name"]').value = option['name'] ?? '';
                                optionEl.querySelector('input[name="option_name_en"]').value = this.getTranslationValue(option, 'name');
                                optionEl.querySelector('select[name="option_type"]').value = option['type'] ?? '';
                                optionEl.querySelector('input[name="option_position"]').value = option['position'] ?? '';
                                optionEl.querySelector('input[name="option_required"]').checked = (option['required'] == '1') ? true : false;
                                optionEl.querySelector('input[name="option_allows_multiple_selection"]').checked = (option['allows_multiple_selection'] == '1') ? true : false;

                                // values
                                if(option['values']){
                                    const valuesEl = optionEl.querySelector('.conf--field-values');
                                    option['values'].forEach(value => {
                                        const valueEl = this.valueTemplate.content.cloneNode(true);
                                        const valueRootEl = valueEl.querySelector('.conf--value');

                                        this.storeExistingTranslations(valueRootEl, value);
                                        valueEl.querySelector('input[name="value_name"]').value = value['name'] ?? '';
                                        valueEl.querySelector('input[name="value_name_en"]').value = this.getTranslationValue(value, 'name');
                                        valueEl.querySelector('input[name="value_value"]').value = value['value'] ?? '';
                                        valueEl.querySelector('input[name="value_position"]').value = value['position'] ?? '';
                                        valueEl.querySelector('input[name="value_surcharge_handle"]').value = value['surcharge_handle'] ?? '';
                                        valueEl.querySelector('input[name="value_surcharge"]').value = value['surcharge'] ?? '';

                                        valuesEl.appendChild(valueEl);
                                    });
                                }
                                

                                optionsEl.appendChild(optionEl);
                            });
                        }

                        this.fieldsEl.appendChild(configuratorEl);

                        // add events for remove buttons
                        this.fieldsEl.querySelectorAll('.option-remove').forEach(btn => {
                            btn.addEventListener('click', (evt) => {
                                evt.preventDefault();
                                this.removeOptionEvent(evt.currentTarget);
                            });
                        });

                        this.fieldsEl.querySelectorAll('.value-remove').forEach(btn => {
                            btn.addEventListener('click', (evt) => {
                                evt.preventDefault();
                                this.removeValueEvent(evt.currentTarget);
                            });
                        });

                        // add events for add buttons
                        this.fieldsEl.querySelectorAll('.option-add-value').forEach(btn => {
                            btn.addEventListener('click', (evt) => {
                                evt.preventDefault();
                                this.addValueEvent(evt.currentTarget);
                            });
                        });

                        this.fieldsEl.querySelector('.conf--add-option').addEventListener('click', (evt) => {
                            evt.preventDefault();
                            const optionsEl = this.fieldsEl.querySelector('.conf--options');
                            const optionEl = this.optionTemplate.content.cloneNode(true);
                            optionEl.querySelector('.option-remove').addEventListener('click', (evt) => {
                                evt.preventDefault();
                                this.removeOptionEvent(evt.currentTarget);
                            });

                            optionEl.querySelector('.option-add-value').addEventListener('click', (evt) => {
                                evt.preventDefault();
                                this.addValueEvent(evt.currentTarget);
                            });
        
                            optionsEl.prepend(optionEl);
                        });
                    }
                }catch(err){
                    console.log(err);
                    this.renderMsg('wrong_text');
                }
            }

            convertUiToText(){
                if(!this.fieldsEl.firstChild){
                    return;
                }

                const newJson = {
                    'data': [],
                    'template': {}
                };

                this.fieldsEl.querySelectorAll('.required-error-msg').forEach(el => {
                    el.remove();
                });

                // template
                newJson['template']['step_by_step_configurator'] = this.fieldsEl.querySelector('input[name="step_by_step_configurator"]').checked ? "1" : "0";

                const templateInfoEl = this.fieldsEl.querySelector('.conf--template-info');
                const displayNameInput = this.fieldsEl.querySelector('input[name="display_name"]');
                if(displayNameInput.value != ""){
                    newJson['template']['display_name'] = displayNameInput.value;
                }else{
                    this.renderInputError(displayNameInput);
                }

                newJson['template']['description'] = this.fieldsEl.querySelector('textarea[name="description"]').value ?? "";
                const templateTranslations = this.buildTranslations(templateInfoEl, 'en', {
                    'display_name': this.fieldsEl.querySelector('input[name="display_name_en"]').value ?? "",
                    'description': this.fieldsEl.querySelector('textarea[name="description_en"]').value ?? ""
                });
                if(templateTranslations){
                    newJson['template']['translations'] = templateTranslations;
                }

                // options
                const optionsEl = this.fieldsEl.querySelectorAll('.conf--options .conf--option');
                optionsEl.forEach(optionEl => {
                    const optionObj = {};

                    const optionNameInput = optionEl.querySelector('input[name="option_name"]');
                    if(optionNameInput.value != ""){
                        optionObj['name'] = optionNameInput.value;
                    }else{
                        this.renderInputError(optionNameInput);
                    }

                    const optionTranslations = this.buildTranslations(optionEl, 'en', {
                        'name': optionEl.querySelector('input[name="option_name_en"]').value ?? ""
                    });
                    if(optionTranslations){
                        optionObj['translations'] = optionTranslations;
                    }

                    const optionTypeInput = optionEl.querySelector('select[name="option_type"]');
                    if(optionTypeInput.value != ""){
                        optionObj['type'] = optionTypeInput.value;
                    }else{
                        this.renderInputError(optionTypeInput);
                    }

                    const optionPositionInput = optionEl.querySelector('input[name="option_position"]');
                    if(optionPositionInput.value != ""){
                        optionObj['position'] = optionPositionInput.value.toString();
                    }else{
                        this.renderInputError(optionPositionInput);
                    }

                    optionObj['required'] = optionEl.querySelector('input[name="option_required"]').checked ? "1" : "0";
                    optionObj['allows_multiple_selection'] = optionEl.querySelector('input[name="option_allows_multiple_selection"]').checked ? "1" : "0";
                    optionObj['values'] = [];

                    // option values
                    const valuesEl = optionEl.querySelectorAll('.conf--field-values .conf--value');
                    valuesEl.forEach(valueEl => {
                        const valueObj = {};

                        valueObj['name'] = valueEl.querySelector('input[name="value_name"]').value ?? "";
                        const valueTranslations = this.buildTranslations(valueEl, 'en', {
                            'name': valueEl.querySelector('input[name="value_name_en"]').value ?? ""
                        });
                        if(valueTranslations){
                            valueObj['translations'] = valueTranslations;
                        }
                        valueObj['value'] = valueEl.querySelector('input[name="value_value"]').value ?? "";
                        valueObj['position'] = valueEl.querySelector('input[name="value_position"]').value ? (valueEl.querySelector('input[name="value_position"]').value.toString()) : "";
                        const surchargeHandleValue = valueEl.querySelector('input[name="value_surcharge_handle"]').value
                        valueObj['surcharge_handle'] = (surchargeHandleValue != "") ? surchargeHandleValue : null;
                        valueObj['surcharge'] = valueEl.querySelector('input[name="value_surcharge"]').value ?? "0";

                        optionObj['values'].push(valueObj);
                    });

                    newJson['data'].push(optionObj);
                });

                if(this.fieldsEl.querySelector('.required-error-msg')){
                    this.renderMsg('ui_to_text_failed');
                    return;
                }

                this.textEl.value = JSON.stringify(newJson);

                this.renderMsg('ui_to_text_success');
            }

            renderMsg(code){
                if(this.message[code]){
                    this.msgEl.innerText = this.message[code]['msg_text'];
                    this.msgEl.classList.add(this.message[code]['class']);
                }
            }

            getTranslationValue(source, fieldName, locale = 'en'){
                return source?.translations?.[locale]?.[fieldName] ?? '';
            }

            storeExistingTranslations(element, source){
                if(source?.translations && typeof source.translations === 'object'){
                    element.dataset.existingTranslations = JSON.stringify(source.translations);
                }
            }

            getExistingTranslations(element){
                const value = element?.dataset?.existingTranslations;
                if(!value){
                    return {};
                }

                try{
                    return JSON.parse(value);
                }catch(err){
                    return {};
                }
            }

            buildTranslations(element, locale, localeValues){
                const translations = this.getExistingTranslations(element);
                delete translations[locale];

                const cleanLocaleValues = {};
                Object.keys(localeValues).forEach(fieldName => {
                    const value = localeValues[fieldName];
                    if(value && value.trim() !== ''){
                        cleanLocaleValues[fieldName] = value;
                    }
                });

                if(Object.keys(cleanLocaleValues).length > 0){
                    translations[locale] = cleanLocaleValues;
                }

                return Object.keys(translations).length > 0 ? translations : null;
            }

            removeOptionEvent(currEl){
                const optionEl = currEl.closest('.conf--option');
                if(optionEl) optionEl.remove();
            }

            removeValueEvent(currEl){
                const valueEl = currEl.closest('.conf--value');
                if(valueEl) valueEl.remove();
            }

            addValueEvent(currEl){
                const optionEl = currEl.closest('.conf--option');
                if(optionEl){
                    const valueEl = this.valueTemplate.content.cloneNode(true);
                    valueEl.querySelector('.value-remove').addEventListener('click', (evt) => {
                        evt.preventDefault();
                        this.removeValueEvent(evt.currentTarget);
                    });
                    optionEl.querySelector('.conf--field-values').prepend(valueEl);
                }
            }

            removeMsg(){
                this.msgEl.innerHTML = '';
                this.msgEl.className = 'configurator-msg';
            }

            renderInputError(element){
                element.insertAdjacentHTML('afterend', `<div class="required-error-msg">This field is empty!</div>`);
            }
            
        }
    );
}
